<template>
  <div class="card shadow h-100">
    <div class="card-header bg-transparent border-0">
      <h6>Total</h6>
    </div>
    <div class="card-body">
      <apexchart width="100%" type="line" :options="chartOptions" :series="series" resizable="true"></apexchart>
    </div>
  </div>
</template>

<script>
import http from "./../../../axios";
export default {
  name: "DeclaracaoInssGraficoDetalhado",
  created: function() {
    this.init();
  },
  methods: {
    init: function() {
      this.getTokens();
      this.getDadosGrafico();
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    },
    getDadosGrafico: function(){
      
      http
        .get(`api/cooperado/${this.tokens.id}/declaracao/grafico`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            for(var i in r.data.result){
              this.series[0].data.push(r.data.result[i].valor_base_inss);
              this.series[1].data.push(r.data.result[i].valor_teto_inss);
            }
          } else {

          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    }
  },
  data: function() {
    return {
      tokens: {},
      chartOptions: {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "15%",
            endingShape: "rounded"
          }
        },
        dataLabels: {
          enabled: false
        },
        responsive: [
          {
            breakpoint: 500,
            options: {
              plotOptions: {
                bar: {
                  horizontal: true,
                  columnWidth: "10%",
                  endingShape: "rounded"
                }
              },
              legend: {
                position: "top"
              }
            }
          }
        ],
        chart: {
          id: "chart",
           zoom: {
          enabled: true,
          type: 'x',  
          autoScaleYaxis: false,  
          zoomedArea: {
            fill: {
              color: '#90CAF9',
              opacity: 0.4
            },
            stroke: {
              color: '#0D47A1',
              opacity: 0.4,
              width: 1
            }
          }
      },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },
        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            shade: "light",
            type: "vertical",
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          }
        },
        colors: ["#115D29", "#8AA021"],
        xaxis: {
          categories: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez"
          ]
        },
        yaxis: {
          labels: {
            formatter: function(value) {
              return "R$ " + value;
            }
          }
        }
      },
      series: [
        {
          name: "Valor Remuneração Base INSS",
          type: "column",
          data: []
        },
        {
          name: "Teto INSS Vigente",
          type: "area",
          data: []
        }
      ]
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssGraficoDetalhado.vue